import { useFormContext } from 'react-hook-form';

import type { AddSingleQuestionConditionsFormType } from './add-single-question-conditions-schema';

export const useAddSingleQuestionConditionsFormContext =
  useFormContext<AddSingleQuestionConditionsFormType>;
